<script>
export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    slice: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loginUrl: `https://hzvlc.resortsbyhyatt.com/agents-sso`,
      email: '',
      password: '',
      errorMessage: '',
    }
  },
  mounted() {
    defineSlice({
      description: 'Agent Portal Login',
      fields: {
        title: { type: 'text', label: 'Title' },
        copy: { type: 'wysiwyg', label: 'Copy' },
        upcoming: { type: 'checkbox', label: 'Upcoming' },
        upcomingImage: { type: 'media', label: 'Upcoming Image', breakpoints: { default: { width: 400, height: 400 } } },
        upcomingLogo: { type: 'media', label: 'Upcoming Logo', breakpoints: { default: { width: 120 } } },
        upcomingTitle: { type: 'text', label: 'Upcoming Title' },
        upcomingCopy: { type: 'wysiwyg', label: 'Upcoming Copy' },
        upcomingLink: { type: 'link', label: 'Upcoming Link', enabled: false },
        showBooking: { type: 'checkbox', label: 'Show Booking Link' },
      },
      name: { label: 'Login', group: 'Agents Portal', layouts: ['AgentCashPlus'] },
      tags: ['Form'],
      templates: [{ label: 'Login', fields: {
        copy: { value: '<p>Become a Playa Preferred Agent and earn points redeemable for either FREE nights or cash! But that\u2019s not all\u2026When you become a Preferred Agent, you\'ll gain access to our online portal built specifically to help you sell! Learn about our resorts, access our exclusive booking engine, download digital assets and much more.&nbsp;<\/p>' },
        showBooking: { value: false },
        title: { value: 'Discover the perks of AgentCash+' },
        upcoming: { value: true },
        upcomingCopy: { value: '<h6>INTRODUCING SEADUST CANCUN<\/h6><p>Situated along the remarkable beaches of fine white sand in the Cancun Hotel Zone, Seadust Cancun Family Resort is much more than a resort. Its impressive views of the famous turquoise waters and the Nichupt\u00E9 Lagoon create the feeling of traveling on a cruise ship completely surrounded by crystal clear waters.<\/p>' },
        upcomingImage: { value: 'https:\/\/playa-cms-assets.s3.amazonaws.com\/media\/seadust\/home\/seadust-cancun-beach-family.jpg' },
        upcomingLink: { value: { text: 'Book Now', target: '_self', relationship: null, href: '\/new-page' } },
        upcomingLogo: { value: 'https:\/\/playa-cms-assets.s3.amazonaws.com\/media\/logos\/23\/seadust-cancun-family-resort-logo-png-1.png' },
        upcomingTitle: { value: 'NOW OPEN' },
      } }],
    })

    const config = useRuntimeConfig()
  },
  methods: {
    async login() {
      await $fetch(
        this.loginUrl,
        {
          method: 'POST',
          body: {
            email: this.email,
            password: this.password,
          },
        },
      ).then((res) => {
        const mbrData = useCookie('mbrAgentData')
        mbrData.value = JSON.stringify(res)
        navigateTo('/home')
      }).catch((err) => {
        console.log('err', err)
        this.errorMessage = 'Invalid email or password'
      })
    },
  },
}
</script>

<template>
  <div class="relative bg-[#012162] text-white font-light max-w-[3200px] mx-auto min-h-screen">
    <div class="w-full max-w-4xl mx-auto px-12 ">
            &nbsp;
      <div class="mt-12 md:grid md:grid-cols-12 md:gap-12">
        <div class="md:col-span-5 flex flex-col justify-center items-center space-y-4">
          <div>
            <svg id="logo" data-v-bed1acfd="" viewBox="-15 -8 490 150" class="w-[90px] sm:w-[150px]"><path fill="currentColor" d="m215.47,136.85c-2.11,1.74-4.57,2.83-7.56,2.83-4.57,0-8.02-2.46-8.02-6.22v-.06c0-2.8,1.86-4.82,5.24-6.1-1.41-1.59-2.04-2.96-2.04-4.54v-.06c0-2.93,2.67-5.48,7.07-5.48,3.9,0,6.54,2.33,6.54,5.26v.06c0,2.86-2.15,4.57-5.42,5.66l4.22,3.8c.95-1.25,1.83-2.68,2.64-4.2l3.27,1.52c-.98,1.74-2.07,3.46-3.34,4.98l3.87,3.48-3.2,2.02-3.27-2.96h0Zm-2.46-2.24l-5.49-4.95c-2.29.87-3.27,2.21-3.27,3.61v.06c0,1.84,1.72,3.17,4.12,3.17,1.69,0,3.24-.72,4.64-1.9h0Zm-.14-11.86v-.06c0-1.46-1.16-2.46-2.81-2.46-1.76,0-2.92,1.09-2.92,2.61v.06c0,1.09.49,1.9,1.86,3.24,2.53-.81,3.87-1.84,3.87-3.39h0Z" /><path fill="currentColor" d="m0,.55h28.84c17.4,0,28.85,9.16,28.85,24.2v.22c0,16.46-13.87,24.96-30.28,24.96H8.7v26.92L0,86.21V.55h0Zm27.74,41.53c12.77,0,21.14-6.76,21.14-16.79v-.22c0-10.9-8.26-16.57-20.7-16.57H8.7v33.57h19.05ZM97.98.55h8.7v68.34h43.38v7.96h-52.07V.55h0Zm121.1-.55h8.15l35.12,76.85h-9.36l-9.03-20.16h-41.95l-9.14,20.16h-8.92L219.08,0h0Zm21.47,48.94l-17.51-38.91-17.61,38.91h35.12Zm73.43-2.29L281.95.55h10.57l25.98,38.15L344.7.55h10.13l-32.04,46v30.3h-8.81v-30.19h0ZM409.55,0h8.15l39.8,86.21-14.04-9.37-9.03-20.16h-41.95l-9.14,20.16h-8.92L409.55,0h0Zm21.47,48.94l-17.5-38.91-17.62,38.91h35.12ZM9.32,117.59h4.33v9.06h11.75v-9.06h4.33v21.78h-4.33v-9.18h-11.75v9.18h-4.33v-21.78h0Zm32.67,10.95v-.06c0-6.13,5.35-11.27,12.91-11.27s12.84,5.07,12.84,11.2v.06c0,6.13-5.35,11.26-12.91,11.26s-12.84-5.07-12.84-11.2h0Zm21.21,0v-.06c0-4.23-3.48-7.75-8.37-7.75s-8.3,3.45-8.3,7.69v.06c0,4.23,3.48,7.75,8.37,7.75s8.3-3.45,8.3-7.69h0Zm21.52-7.41h-7.81v-3.55h19.98v3.55h-7.81v18.24h-4.36v-18.24h0Zm23.07-3.55h18.26v3.42h-13.93v5.66h12.35v3.42h-12.35v5.85h14.11v3.42h-18.43v-21.78h0Zm30.6,0h4.33v18.3h12.95v3.49h-17.27v-21.78h0Zm27.15,18.61l2.6-2.74c2.36,1.8,4.71,2.83,7.77,2.83,2.67,0,4.36-1.09,4.36-2.74v-.06c0-1.56-.99-2.4-5.56-3.33-5.24-1.12-8.2-2.49-8.2-6.5v-.06c0-3.73,3.52-6.32,8.41-6.32,3.59,0,6.44.96,8.94,2.74l-2.32,2.89c-2.22-1.46-4.43-2.24-6.68-2.24-2.53,0-4.01,1.15-4.01,2.58v.06c0,1.68,1.13,2.43,5.84,3.42,5.21,1.12,7.92,2.77,7.92,6.38v.06c0,4.08-3.62,6.5-8.79,6.5-3.76,0-7.32-1.15-10.27-3.49h0Zm74.67-18.61h10.98c3.1,0,5.52.81,7.11,2.18,1.3,1.18,2.04,2.8,2.04,4.7v.06c0,3.58-2.43,5.73-5.87,6.6l6.65,8.25h-5.1l-6.05-7.59h-5.42v7.59h-4.33v-21.78h0Zm10.66,10.8c3.1,0,5.07-1.43,5.07-3.64v-.06c0-2.33-1.9-3.61-5.1-3.61h-6.3v7.31h6.33Zm21.81-10.8h18.26v3.42h-13.93v5.66h12.35v3.42h-12.35v5.85h14.11v3.42h-18.43v-21.78h0Zm28.95,18.61l2.6-2.74c2.36,1.8,4.71,2.83,7.78,2.83,2.67,0,4.36-1.09,4.36-2.74v-.06c0-1.56-.99-2.4-5.56-3.33-5.24-1.12-8.2-2.49-8.2-6.5v-.06c0-3.73,3.52-6.32,8.41-6.32,3.59,0,6.44.96,8.94,2.74l-2.32,2.89c-2.22-1.46-4.43-2.24-6.68-2.24-2.53,0-4.01,1.15-4.01,2.58v.06c0,1.68,1.13,2.43,5.84,3.42,5.21,1.12,7.92,2.77,7.92,6.38v.06c0,4.08-3.62,6.5-8.79,6.5-3.76,0-7.32-1.15-10.27-3.49h0Zm29.76-7.66v-.06c0-6.13,5.35-11.27,12.91-11.27s12.84,5.07,12.84,11.2v.06c0,6.13-5.35,11.26-12.91,11.26s-12.84-5.07-12.84-11.2h0Zm21.21,0v-.06c0-4.23-3.48-7.75-8.37-7.75s-8.3,3.45-8.3,7.69v.06c0,4.23,3.48,7.75,8.37,7.75s8.3-3.45,8.3-7.69h0Zm16.81-10.95h10.98c3.1,0,5.52.81,7.11,2.18,1.3,1.18,2.04,2.8,2.04,4.7v.06c0,3.58-2.43,5.73-5.87,6.6l6.65,8.25h-5.1l-6.05-7.59h-5.42v7.59h-4.33v-21.78h0Zm10.66,10.8c3.1,0,5.07-1.43,5.07-3.64v-.06c0-2.33-1.9-3.61-5.1-3.61h-6.3v7.31h6.33Zm27.43-7.25h-7.81v-3.55h19.98v3.55h-7.81v18.24h-4.36v-18.24h0Zm21.6,15.06l2.6-2.74c2.36,1.8,4.71,2.83,7.77,2.83,2.67,0,4.36-1.09,4.36-2.74v-.06c0-1.56-.99-2.4-5.56-3.33-5.24-1.12-8.2-2.49-8.2-6.5v-.06c0-3.73,3.52-6.32,8.41-6.32,3.59,0,6.44.96,8.94,2.74l-2.32,2.89c-2.22-1.46-4.43-2.24-6.68-2.24-2.53,0-4.01,1.15-4.01,2.58v.06c0,1.68,1.13,2.43,5.84,3.42,5.21,1.12,7.92,2.77,7.92,6.38v.06c0,4.08-3.62,6.5-8.79,6.5-3.76,0-7.32-1.15-10.27-3.49h0Zm38.11-13.06c0,3.37-2.65,6.02-6.09,6.02s-6.13-2.65-6.13-6.02,2.72-5.95,6.13-5.95,6.09,2.65,6.09,5.95h0Zm-10.7,0c0,2.65,1.96,4.75,4.64,4.75s4.53-2.1,4.53-4.71-1.92-4.79-4.57-4.79-4.61,2.14-4.61,4.75h0Zm3.66,3.12h-1.38v-5.95c.54-.11,1.3-.18,2.29-.18,1.12,0,1.63.18,2.07.44.32.25.58.72.58,1.3,0,.65-.51,1.16-1.23,1.38v.07c.58.22.91.65,1.09,1.45.18.91.29,1.27.44,1.49h-1.49c-.18-.22-.29-.76-.47-1.45-.11-.65-.47-.94-1.23-.94h-.65v2.39h0Zm.04-3.37h.65c.76,0,1.38-.25,1.38-.87,0-.54-.4-.91-1.27-.91-.36,0-.62.04-.76.07v1.71h0Z" /></svg>
          </div>
          <LogosAgentCashPlus class="w-full max-w-[300px] text-white" />
          <h1 class="text-2xl text-white font-thin">
            Travel Professional Portal
          </h1>
        </div>
        <div class="mt-12 md:mt-0 md:col-span-7 flex items-end">
          <div class="w-full">
            <form class="login" method="POST" accept-charset="UTF-8" @submit.prevent="login">
              <div class="flex flex-col">
                <div class="w-full flex items-end space-x-4 border-b border-white pb-1  text-xs">
                  <label class="block uppercase w-24" for="member-login">Member Login:</label>
                  <input
                    id="member-login"
                    v-model="email"
                    class="flex-1 bg-transparent border-none focus:outline-none text-sm" name="email" type="email"
                  >
                </div>
                <div class="mt-8 w-full flex items-end space-x-4 border-b border-white pb-1  text-xs">
                  <label class="block uppercase w-24 " for="member-password">Password:</label>
                  <input
                    id="member-password"
                    v-model="password" class="flex-1 bg-transparent border-none focus:outline-none text-sm"
                    name="password" type="password"
                  >
                </div>
                <fieldset class="mt-8 buttons">
                  <div v-if="errorMessage" class="bg-red-700 p-2 mb-6 border">
                    {{ errorMessage }}
                  </div>
                  <div class="flex items-center text-sm space-x-4">
                    <button class="bg-white rounded-full px-6 py-1.5 text-playa-dark-blue">
                      Log
                      In
                    </button>
                    <a href="https://mbr.agentcashplus.com/v2/pwd/recover" class="underline">Forgot
                      Password</a>
                  </div>
                  <div class="text-sm mt-6 ">
                    Don't have an account?
                    <a href="https://mbr.agentcashplus.com/v2/register" class="underline">Register</a>
                  </div>
                </fieldset>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="mt-12 pb-8">
        <h2 class="font-bold text-2xl">
          {{ fields.title.value }}
        </h2>
        <div class="mt-4 text-base bold-links underline-links underline-offset-4" v-html="fields.copy.value" />
        <div class="mt-4 flex flex-col items-start space-y-4 space-x-0 md:flex-row md:space-y-0 md:space-x-2 ">
          <a href="/agent-cash-plus" class="bg-white rounded-full px-6 py-1.5 text-playa-dark-blue">Learn
            More</a>
          <a href="/terms-and-conditions" class="bg-white rounded-full px-6 py-1.5 text-playa-dark-blue">Terms & Conditions</a>
        </div>
      </div>

      <div v-if="fields.upcoming.value" class="relative z-10 mt-12 bg-white text-gray-500">
        <div class="md:grid md:grid-cols-5">
          <div class="col-span-2 h-64 md:h-auto">
            <VoixMedia :field="fields.upcomingImage" class="w-full h-full object-cover" />
          </div>
          <div class="col-span-3 flex flex-col p-6">
            <VoixMedia :field="fields.upcomingLogo" class="w-fit max-h-[75px]" />
            <div class="text-lg font-medium">
              {{ fields.upcomingTitle.value }}
            </div>
            <div class="mt-2 text-xs" v-html="fields.upcomingCopy.value" />
            <div class="flex items-center space-x-4">
              <a
                v-if="fields.upcomingLink.enabled" :href="fields.upcomingLink.value?.href"
                :target="fields.upcomingLink.value?.target"
                class="inline-block mt-4 text-xs uppercase font-medium text-white bg-[#012162] rounded-full px-4 py-2"
              >
                {{ fields.upcomingLink.value?.text }}
              </a>

              <PlayaBooking v-if="fields.showBooking.value" :remote-enabled="true">
                <button
                  class="inline-block mt-4 text-xs uppercase font-medium text-white bg-[#012162] rounded-full px-4 py-2"
                >
                  Book Now
                </button>
              </PlayaBooking>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'md:-mt-72': fields.upcoming.value }">
      <img src="/imgs/agentcashplus/login-footer-background.jpg" class="w-full">
    </div>
  </div>
</template>
